var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconsaxYoutube(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2955_87)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2955_87",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -1,
    y: 0,
    width: 17,
    height: 17
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.6699 0.444336H-0.330078V16.4443H15.6699V0.444336Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2955_87)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.0039 3.11084H4.33724C2.33724 3.11084 1.00391 4.44417 1.00391 6.44417V10.4442C1.00391 12.4442 2.33724 13.7775 4.33724 13.7775H11.0039C13.0039 13.7775 14.3372 12.4442 14.3372 10.4442V6.44417C14.3372 4.44417 13.0039 3.11084 11.0039 3.11084ZM8.93057 9.13084L7.28391 10.1175C6.61724 10.5175 6.07056 10.2108 6.07056 9.43084V7.45084C6.07056 6.67085 6.61724 6.36418 7.28391 6.76418L8.93057 7.75084C9.56391 8.13751 9.56391 8.75084 8.93057 9.13084Z",
    fill: "#F92222"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2955_87"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsaxYoutube);
export default __webpack_public_path__ + "static/media/iconsax-youtube.9e73f25c1678d9c190d2dd080ed27180.svg";
export { ForwardRef as ReactComponent };